import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import { styled } from "@mui/material";
import { memo } from "react";
import Box from "../../../../node_modules/@mui/material/Box/Box.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Wrapping } from "../../../foundations/wrapping.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
const CustomBox = styled(Box, styledOptions)(({
  gap
}) => ({
  display: Displaying.flex,
  flexWrap: Wrapping.wrap,
  justifyContent: Alignment.flexStart,
  gap
}));
const DualGridCardLayoutContentWrapper = memo(CustomBox);
export {
  DualGridCardLayoutContentWrapper
};
//# sourceMappingURL=content-wrapper.es.js.map
